import React from 'react'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Trash2 as Trash2Icon } from 'react-feather'
import { KeyboardArrowUp as KeyboardArrowUpIcon } from '@material-ui/icons'
import { Box, Chip, IconButton, Typography } from '@material-ui/core'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import useStyles from './styles'

const PlanActionFormHeader = ({
  id,
  isDraft = false,
  openCollapse = false,
  setOpenCollapse,
  onDelete,
}) => {
  const classes = useStyles()
  const { isShow } = useThirdPartyManagementStepper()

  const handleChangeCollapse = () => setOpenCollapse((previous) => !previous)

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      px={3}
      py={2}
    >
      <Typography variant="h6">
        {isDraft ? 'Plano de Ação' : `#${id} - Plano de Ação`}
      </Typography>
      <Box display="flex" alignItems="center" gridGap={8}>
        {isDraft && (
          <Chip size="small" label="Rascunho" className={classes.draftChip} />
        )}
        {!isShow && (
          <IconButton size="small" onClick={onDelete}>
            <Trash2Icon size={20} />
          </IconButton>
        )}
        <IconButton size="small" onClick={handleChangeCollapse}>
          <KeyboardArrowUpIcon
            className={clsx(classes.arrow, {
              [classes.arrowOpen]: openCollapse,
            })}
          />
        </IconButton>
      </Box>
    </Box>
  )
}

PlanActionFormHeader.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isDraft: PropTypes.bool,
  openCollapse: PropTypes.bool,
  setOpenCollapse: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default PlanActionFormHeader
